module.exports = __webpack_public_path__ + "media/images/country_flags/tj-2310bcea0690173c747e5b0a9028644e.png";